module.exports = class sasacHome {};
